import { getModelProvider, type ModelSelection } from '~/lib/common/models';
import type { Doc } from '@convex/_generated/dataModel';

export function hasApiKeySet(
  modelSelection: ModelSelection,
  useGeminiAuto: boolean,
  apiKey?: Doc<'convexMembers'>['apiKey'] | null,
) {
  if (!apiKey) {
    return false;
  }

  const provider = getModelProvider(modelSelection);

  switch (provider) {
    case 'auto':
      if (useGeminiAuto) {
        return !!apiKey.google?.trim();
      }
      return !!apiKey.value?.trim();
    case 'anthropic':
      return !!apiKey.value?.trim();
    case 'openai':
      return !!apiKey.openai?.trim();
    case 'xai':
      return !!apiKey.xai?.trim();
    case 'google':
      return !!apiKey.google?.trim();
    case 'openrouter':
      return !!apiKey.openrouter?.trim();
    default: {
      const _exhaustiveCheck: never = provider;
      return false;
    }
  }
}

export function hasAnyApiKeySet(apiKey?: Doc<'convexMembers'>['apiKey'] | null) {
  if (!apiKey) {
    return false;
  }
  return Object.entries(apiKey).some(([key, value]) => {
    if (key === 'preference') {
      return false;
    }
    if (typeof value === 'string') {
      return value.trim() !== '';
    }
    return false;
  });
}
